// Requirements summary:
// - Athlete dashboard deep-link logins set a one-time staff-shell hint so a
//   gym staff member who had parent mode saved from a prior visit does not
//   appear to become a parent account after authentication.
// - Two consumers share this state via sessionStorage: SignInForm (writes the
//   hint when the redirect target is a staff-style athlete URL) and
//   UserRoleContext (reads the hint during the first post-login role
//   resolution and clears it once applied).
// - These helpers previously lived next to the same-account dual-persona
//   switching code, which has been removed (plan
//   docs/plans/2026-05-23-002-feat-unified-account-holder-signup-plan.md).
//   They are isolated here so the staff-deep-link safety guard survives
//   independently of the deleted persona-toggle feature surface.

export const FORCE_STAFF_PERSONA_AFTER_LOGIN_KEY = 'forceStaffPersonaAfterLogin';

export function shouldForceStaffPersonaAfterLogin(destination: string): boolean {
  const pathname = destination.split(/[?#]/, 1)[0];
  return pathname === '/dashboard/athletes' || pathname.startsWith('/dashboard/athletes/');
}
